import { Component, EventEmitter, Input, Output  } from '@angular/core';
@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  @Input() visible = false;
  /** Largura máxima opcional do modal (qualquer unidade CSS: 600px, 70%, 90vw...).
   *  Se não informado, usa a largura padrão do componente (720px). */
  @Input() maxWidth?: string;

  @Output() close = new EventEmitter<void>();

  handleClose(): void {
    this.close.emit();
  }
}
